export { default as MediaCollectionChapter } from './MediaCollectionChapter';
